import React, { useEffect, useState, useRef, createElement } from 'react';
const customCSS = `
  @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;0,600;1,300;1,400;1,500&family=Playfair+Display:ital,wght@0,400;0,600;0,700;1,400&family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

  :root {
    --brand-50: #fdfcf7;
    --brand-100: #f7f1e1;
    --brand-200: #ecdfb8;
    --brand-300: #d9bf7d;
    --brand-400: #c9a961;
    --brand-500: #b8924a;
    --brand-600: #9a7838;
    --brand-700: #7a5f2c;
    --brand-800: #4a3a1a;
    --brand-900: #1a1410;
    --ink: #18120a;
    --cream: #fafaf6;
  }

  body {
    background-color: #fafaf6;
    color: #18120a;
    font-family: 'Plus Jakarta Sans', sans-serif;
  }

  .font-serif {
    font-family: 'Cormorant Garamond', 'Playfair Display', serif;
  }

  .font-sans {
    font-family: 'Plus Jakarta Sans', sans-serif;
  }

  .bg-cream { background-color: #fafaf6; }
  .text-ink { color: #18120a; }

  .bg-brand-50 { background-color: #fdfcf7; }
  .bg-brand-100 { background-color: #f7f1e1; }
  .bg-brand-200 { background-color: #ecdfb8; }
  .bg-brand-300 { background-color: #d9bf7d; }
  .bg-brand-400 { background-color: #c9a961; }
  .bg-brand-500 { background-color: #b8924a; }
  .bg-brand-600 { background-color: #9a7838; }
  .bg-brand-700 { background-color: #7a5f2c; }
  .bg-brand-800 { background-color: #4a3a1a; }
  .bg-brand-900 { background-color: #1a1410; }

  .text-brand-500 { color: #b8924a; }
  .text-brand-600 { color: #9a7838; }
  .text-brand-700 { color: #7a5f2c; }
  .text-brand-800 { color: #4a3a1a; }
  .text-brand-900 { color: #1a1410; }

  .border-brand-100 { border-color: #f7f1e1; }
  .border-brand-200 { border-color: #ecdfb8; }
  .border-brand-300 { border-color: #d9bf7d; }
  .border-brand-400 { border-color: #c9a961; }
  .border-brand-500 { border-color: #b8924a; }

  .fill-brand-500 { fill: #b8924a; }

  .selection\\:bg-brand-200 ::selection { background-color: #ecdfb8; }
  .selection\\:text-brand-900 ::selection { color: #1a1410; }

  .shadow-glass {
    box-shadow: 0 12px 40px rgba(184, 146, 74, 0.1);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
  }

  .shadow-xs { box-shadow: 0 1px 2px rgba(0,0,0,0.04); }

  .gold-glow {
    filter: drop-shadow(0 0 20px rgba(217, 191, 125, 0.45));
  }

  @keyframes soft-pulse {
    0%, 100% { transform: scale(1); box-shadow: 0 10px 30px -5px rgba(184, 146, 74, 0.3); }
    50% { transform: scale(1.03); box-shadow: 0 20px 40px -5px rgba(184, 146, 74, 0.5); }
  }

  .animate-pulse-gold {
    animation: soft-pulse 3.5s infinite ease-in-out;
  }

  @keyframes fade-in {
    from { opacity: 0; }
    to { opacity: 1; }
  }
  .animate-fade-in { animation: fade-in 0.25s ease-out; }

  .text-4\\.5xl { font-size: 2.5rem; line-height: 1; }
  .w-5\\.5 { width: 1.375rem; }
  .h-5\\.5 { height: 1.375rem; }
  .p-4\\.5 { padding: 1.125rem; }
  .backdrop-blur-xs { backdrop-filter: blur(4px); -webkit-backdrop-filter: blur(4px); }
`;
const Icons = {
  Star: ({
    className = 'w-4 h-4 text-brand-500 fill-brand-500'
  }) => <svg className={className} fill="currentColor" viewBox="0 0 24 24" stroke="none" data-id="element-0">
      <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" data-id="element-1" />
    </svg>,
  Check: ({
    className = 'w-4 h-4 text-brand-600'
  }) => <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2.5" data-id="element-2">
      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-3" />
    </svg>,
  X: ({
    className = 'w-4 h-4 text-gray-400'
  }) => <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2.5" data-id="element-4">
      <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" data-id="element-5" />
    </svg>,
  ChevronDown: ({
    className = 'w-5 h-5 text-brand-500'
  }) => <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" data-id="element-6">
      <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" data-id="element-7" />
    </svg>,
  Shield: ({
    className = 'w-5 h-5'
  }) => <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5" data-id="element-8">
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z" data-id="element-9" />
    </svg>,
  Flame: ({
    className = 'w-5 h-5'
  }) => <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5" data-id="element-10">
      <path strokeLinecap="round" strokeLinejoin="round" d="M15.362 5.214A8.252 8.252 0 0112 21 8.25 8.25 0 016.038 7.048 8.287 8.287 0 009 9.6a8.983 8.983 0 013.361-6.867 8.21 8.21 0 003 2.48z" data-id="element-11" />
    </svg>,
  Moon: ({
    className = 'w-5 h-5'
  }) => <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5" data-id="element-12">
      <path strokeLinecap="round" strokeLinejoin="round" d="M21.752 15.002A9.718 9.718 0 0118 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 003 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 009.002-5.998z" data-id="element-13" />
    </svg>,
  Heart: ({
    className = 'w-5 h-5'
  }) => <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5" data-id="element-14">
      <path strokeLinecap="round" strokeLinejoin="round" d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z" data-id="element-15" />
    </svg>,
  Sparkles: ({
    className = 'w-5 h-5'
  }) => <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5" data-id="element-16">
      <path strokeLinecap="round" strokeLinejoin="round" d="M9.813 15.904L9 21l-.813-5.096L3 15l5.096-.813L9 9l.813 5.096L15 15l-5.096.813zM18.813 6.904L18 12l-.813-5.096L12 6l5.096-.813L18 0l.813 5.096L24 6l-5.096.813z" data-id="element-17" />
    </svg>,
  Acupressure: ({
    className = 'w-5 h-5'
  }) => <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5" data-id="element-18">
      <circle cx="12" cy="12" r="10" data-id="element-19" />
      <path d="M12 8v8M8 12h8" data-id="element-20" />
    </svg>
};
const colorMap: Record<string, {
  name: string;
  hex: string;
  img: string;
}> = {
  Plata: {
    name: 'Plateado Platino',
    hex: '#98999d',
    img: 'https://tiendaatmosfera.com/cdn/shop/files/imagen_final.jpg?v=1779117073&width=1240'
  },
  Oro: {
    name: 'Dorado Champagne',
    hex: '#ead197',
    img: 'https://tiendaatmosfera.com/cdn/shop/files/1_ring.webp?v=1771468095&width=1240'
  },
  'Oro Rosa': {
    name: 'Oro Rosa',
    hex: '#e3c6b5',
    img: 'https://tiendaatmosfera.com/cdn/shop/files/Calmara-Magnetig-Rose-Gold-Ring-angle5.webp?v=1771468095&width=1240'
  },
  Negro: {
    name: 'Negro Obsidiana',
    hex: '#000000',
    img: 'https://tiendaatmosfera.com/cdn/shop/files/Calmara_Ring_Jet_Black.webp?v=1771468095&width=1240'
  }
};
export function App() {
  const [selectedPack, setSelectedPack] = useState('double');
  const [selectedColor, setSelectedColor] = useState('Plata');
  const [isCheckoutOpen, setIsCheckoutOpen] = useState(false);
  const [orderCompleted, setOrderCompleted] = useState(false);
  useEffect(() => {
    const styleTag = document.createElement('style');
    styleTag.innerHTML = customCSS;
    document.head.appendChild(styleTag);
    return () => {
      document.head.removeChild(styleTag);
    };
  }, []);
  const handleOpenCheckout = (pack: string, color: string) => {
    setSelectedPack(pack);
    setSelectedColor(color);
    setIsCheckoutOpen(true);
  };
  return <div className="min-h-screen bg-cream font-sans selection:bg-brand-200 selection:text-brand-900" data-id="element-21">
      <main className="max-w-md mx-auto bg-white min-h-screen shadow-2xl relative overflow-hidden flex flex-col justify-between border-x border-brand-200/20" data-id="element-22">
        <div className="absolute w-96 h-96 rounded-full bg-[#fdfcf7] blur-3xl -top-32 -right-20 pointer-events-none" data-id="element-23" />
        <div className="absolute w-80 h-80 rounded-full bg-[#ecdfb8]/20 blur-3xl top-[600px] -left-32 pointer-events-none" data-id="element-24" />
        <div className="absolute w-72 h-72 rounded-full bg-[#d9bf7d]/15 blur-3xl top-[1400px] -right-24 pointer-events-none" data-id="element-25" />
        <div className="absolute w-96 h-96 rounded-full bg-[#b8924a]/10 blur-3xl top-[2200px] -left-28 pointer-events-none" data-id="element-26" />
        <div className="absolute w-80 h-80 rounded-full bg-[#ecdfb8]/20 blur-3xl top-[3000px] -right-32 pointer-events-none" data-id="element-27" />

        <div data-id="element-28">
          <Header data-id="element-29" />
          <Hero selectedColor={selectedColor} setSelectedColor={setSelectedColor} onBuyClick={() => handleOpenCheckout(selectedPack, selectedColor)} data-id="element-30" />
          <PressArticles data-id="element-31" />
          <NaturalCallout data-id="element-32" />
          <ANMATWarning data-id="element-33" />
          <ZebrahouseCustom data-id="element-34" />
          <Reason1 data-id="element-35" />
          <Reason2 data-id="element-36" />
          <UGCVideos data-id="element-37" />
          <Reason3 data-id="element-38" />
          <ScienceSection data-id="element-39" />
          <Reason4 data-id="element-40" />
          <Reason5 data-id="element-41" />
          <ComfortRichText data-id="element-42" />
          <ProductSummary data-id="element-43" />
          <ObjectionsBlock data-id="element-44" />
          <PricingSection selectedColor={selectedColor} setSelectedColor={setSelectedColor} selectedPack={selectedPack} setSelectedPack={setSelectedPack} onBuyClick={handleOpenCheckout} data-id="element-45" />
          <ReviewsSection data-id="element-46" />
          <FAQ data-id="element-47" />
          <FinalCTA data-id="element-48" />
        </div>

        <Footer data-id="element-49" />

        {isCheckoutOpen && <CheckoutModal pack={selectedPack} color={selectedColor} onClose={() => {
        setIsCheckoutOpen(false);
        setOrderCompleted(false);
      }} orderCompleted={orderCompleted} setOrderCompleted={setOrderCompleted} data-id="element-50" />}
      </main>
    </div>;
}
export function Header() {
  return <header className="sticky top-0 z-40 w-full bg-white/90 backdrop-blur-md border-b border-brand-200/40" data-id="element-51">
      <div className="bg-[#18120a] text-white text-[10px] sm:text-xs font-semibold text-center py-2.5 tracking-widest uppercase px-2" data-id="element-52">
        ✦ BAJÁ DE PESO SIN DIETAS NI EJERCICIO • ENVÍO GRATIS ✦
      </div>
      <div className="flex items-center justify-center px-5 py-3.5" data-id="element-53">
        <img src="https://tiendaatmosfera.com/cdn/shop/files/Negro.png?v=1769627225&width=170" alt="ATMOSFERA" className="h-6 object-contain" data-id="element-54" />
      </div>
    </header>;
}
export function Hero({
  selectedColor,
  setSelectedColor,
  onBuyClick
}: any) {
  const scrollToBuy = () => {
    document.getElementById('comprar')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="px-5 pt-8 pb-10 text-center relative" data-id="element-55">
      <div className="inline-flex items-center gap-1.5 bg-[#fdfcf7] border border-[#d9bf7d]/40 text-[#7a5f2c] px-4 py-1.5 rounded-full text-[11px] font-bold mb-6 shadow-sm" data-id="element-56">
        <Icons.Sparkles className="w-3.5 h-3.5 text-[#b8924a]" data-id="element-57" />
        Más de 10.000 argentinas ya bajaron de peso
      </div>

      <h2 className="font-serif text-[40px] leading-[1.1] font-light text-[#18120a] mb-4" data-id="element-58">
        5 razones para bajar de peso con el <br data-id="element-59" />
        <span className="italic text-[#9a7838] font-normal font-serif" data-id="element-60">
          Anillo Atmósfera
        </span>
      </h2>

      <div className="flex justify-center mb-5" data-id="element-61">
        <div className="w-16 h-0.5 bg-[#c9a961]/40 rounded-full" data-id="element-62" />
      </div>

      <p className="text-[#4a3a1a] text-sm font-medium mb-8 max-w-sm mx-auto leading-relaxed" data-id="element-63">
        Si después de los 45 sentís que ya nada te funciona —ni las dietas, ni
        las caminatas, ni dejar el pan—, no es tu fuerza de voluntad. Es tu
        cortisol. El Anillo Atmósfera activa puntos de acupresión quemagrasa
        para que vuelvas a bajar de peso de forma natural, sin dietas, sin
        gimnasio, sin pastillas.
      </p>

      <div className="relative mx-auto w-full max-w-[290px] aspect-[4/5] rounded-[36px] overflow-hidden shadow-glass bg-gradient-to-b from-white to-brand-50/50 border border-white/80 p-3 ring-1 ring-brand-300/20 mb-8 group" data-id="element-64">
        <img src={colorMap[selectedColor].img} alt={`Anillo Atmósfera ${selectedColor}`} className="w-full h-full object-cover rounded-[28px] transition-all duration-700 group-hover:scale-105" data-id="element-65" />

        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-white/90 backdrop-blur-md px-4 py-2.5 rounded-full flex gap-3 shadow-md border border-brand-100/50" data-id="element-66">
          {Object.keys(colorMap).map(colorKey => <button key={colorKey} onClick={() => setSelectedColor(colorKey)} className={`w-5.5 h-5.5 rounded-full border-2 transition-all active:scale-90 ${selectedColor === colorKey ? 'border-[#b8924a] scale-110 shadow-xs' : 'border-transparent opacity-70'}`} style={{
          backgroundColor: colorMap[colorKey].hex
        }} title={colorMap[colorKey].name} data-id="element-67" />)}
        </div>
      </div>

      <button onClick={scrollToBuy} className="w-full max-w-[280px] bg-[#b8924a] hover:bg-[#9a7838] text-white font-bold tracking-widest uppercase py-4 px-6 rounded-full shadow-lg transition-all active:scale-98 animate-pulse-gold text-xs" data-id="element-68">
        QUIERO EL ANILLO ATMÓSFERA
      </button>
    </section>;
}
export function PressArticles() {
  const articles = [{
    outlet: 'INFOSUR DIARIO',
    outletAccent: 'text-red-700',
    date: 'Marzo 2026',
    headline: '"Un anillo con imanes que promete reducir el estrés y mejorar el sueño: qué dice la ciencia"',
    img: 'https://cdn.magicpatterns.com/uploads/qf2R3W9tWvA5yyYhJ1wiu4/Captura_de_pantalla_2026-06-02_a_la(s)_8.02.15_p._m..png',
    url: 'https://infosurdiario.com.ar/un-anillo-con-imanes-que-promete-reducir-el-estres-y-mejorar-el-sueno-que-dice-la-ciencia/',
    rotate: '-rotate-3',
    offset: 'translate-x-0 translate-y-0',
    z: 'z-10'
  }, {
    outlet: 'INFO BLANCO SOBRE NEGRO',
    outletAccent: 'text-[#18120a]',
    date: '15 Abr 2026',
    headline: '"La marca argentina Atmósfera lanzó un accesorio de magnetoterapia que combina cuatro imanes posicionados sobre puntos de acupresión."',
    img: 'https://cdn.magicpatterns.com/uploads/i4beoFWjZz426jSK5fBwQJ/Captura_de_pantalla_2026-06-02_a_la(s)_8.02.09_p._m..png',
    url: 'https://www.infoblancosobrenegro.com/nota/112389/un-anillo-con-imanes-que-promete-reducir-el-estres-y-mejorar-el-sueno-que-dice-la-ciencia/',
    rotate: 'rotate-3',
    offset: 'translate-x-6 translate-y-10',
    z: 'z-20'
  }];
  return <section className="px-5 py-10 bg-gradient-to-b from-[#fdfcf7] to-white border-y border-[#ecdfb8]/30 relative overflow-hidden" data-id="element-69">
      <div className="absolute w-64 h-64 rounded-full bg-[#ecdfb8]/40 blur-3xl -top-10 -right-20 pointer-events-none" data-id="element-70" />
      <div className="absolute w-72 h-72 rounded-full bg-[#d9bf7d]/20 blur-3xl bottom-0 -left-20 pointer-events-none" data-id="element-71" />

      <div className="relative" data-id="element-72">
        <div className="mb-6" data-id="element-73">
          <span className="inline-block text-[10px] font-bold text-[#7a5f2c] uppercase tracking-[0.2em] mb-3 bg-white border border-[#ecdfb8] px-3 py-1 rounded-full" data-id="element-74">
            ✦ Como se vio en la prensa ✦
          </span>
          <h3 className="font-serif text-[28px] leading-tight font-light text-[#18120a] mb-3" data-id="element-75">
            La prensa argentina
            <br data-id="element-76" />
            <span className="italic text-[#9a7838]" data-id="element-77">ya habló de nosotras</span>
          </h3>
          <p className="text-xs sm:text-sm text-[#4a3a1a] leading-relaxed max-w-sm" data-id="element-78">
            Dos medios independientes investigaron qué es el Anillo Atmósfera,
            cómo funciona y qué dice la ciencia detrás de los campos magnéticos
            aplicados sobre puntos de acupresión. Acá podés leer las notas
            completas.
          </p>
        </div>

        {/* Stacked article screenshots */}
        <div className="relative h-[460px] sm:h-[490px] mb-6 mx-auto max-w-[320px]" data-id="element-79">
          {articles.map((a, i) => <a key={i} href={a.url} target="_blank" rel="noopener noreferrer" className={`absolute top-0 left-0 w-[200px] sm:w-[215px] transform ${a.rotate} ${a.offset} ${a.z} transition-all duration-500 hover:rotate-0 hover:scale-105 hover:z-30`} data-id="element-80">
              <div className="bg-white rounded-2xl border border-[#ecdfb8]/60 shadow-2xl overflow-hidden ring-1 ring-black/5" data-id="element-81">
                <div className="aspect-[3/4] overflow-hidden bg-gray-50" data-id="element-82">
                  <img src={a.img} alt={`Captura de ${a.outlet}`} className="w-full h-full object-cover object-top" data-id="element-83" />
                </div>
                <div className="px-3 py-2.5 bg-white border-t border-[#ecdfb8]/40" data-id="element-84">
                  <div className="flex items-center justify-between mb-1" data-id="element-85">
                    <span className={`font-serif font-extrabold text-[9px] tracking-[0.12em] ${a.outletAccent}`} data-id="element-86">
                      {a.outlet}
                    </span>
                    <span className="text-[8px] text-[#7a5f2c] font-medium" data-id="element-87">
                      {a.date}
                    </span>
                  </div>
                  <p className="text-[9px] text-[#4a3a1a] leading-snug italic line-clamp-3" data-id="element-88">
                    {a.headline}
                  </p>
                </div>
              </div>
            </a>)}

          {/* Decorative quote mark */}
          <span className="absolute -top-4 -left-2 font-serif text-[140px] text-[#ecdfb8]/40 leading-none select-none pointer-events-none italic" data-id="element-89">
            "
          </span>
        </div>

        {/* Outlet badges + CTA row */}
        <div className="bg-white/70 backdrop-blur rounded-3xl border border-[#ecdfb8]/50 p-4 shadow-sm" data-id="element-90">
          <div className="flex items-center justify-around mb-3 pb-3 border-b border-[#ecdfb8]/40" data-id="element-91">
            <span className="font-serif font-extrabold text-xs tracking-[0.12em] text-red-700" data-id="element-92">
              INFOSUR
            </span>
            <div className="w-px h-5 bg-[#ecdfb8]" data-id="element-93" />
            <span className="font-serif font-extrabold text-xs tracking-[0.12em] text-[#18120a]" data-id="element-94">
              INFO BLANCO/NEGRO
            </span>
          </div>
          <div className="flex items-center justify-center gap-2 text-[10px] text-[#7a5f2c]" data-id="element-95">
            <Icons.Check className="w-3.5 h-3.5 text-emerald-600" data-id="element-96" />
            <span className="font-bold" data-id="element-97">
              Tocá una nota para leerla completa
            </span>
          </div>
        </div>
      </div>
    </section>;
}
export function NaturalCallout() {
  const pillars = [{
    label: 'Sin pastillas',
    icon: '💊'
  }, {
    label: 'Sin suplementos',
    icon: '🌿'
  }, {
    label: 'Sin hormonas',
    icon: '⚗️'
  }, {
    label: 'Sin químicos',
    icon: '✦'
  }];
  return <section className="px-5 py-10 bg-gradient-to-b from-white to-[#fdfcf7]" data-id="element-98">
      <div className="bg-white rounded-[32px] border border-[#ecdfb8] shadow-glass p-6 relative overflow-hidden" data-id="element-99">
        <div className="absolute w-40 h-40 rounded-full bg-emerald-100/40 blur-2xl -top-10 -right-10 pointer-events-none" data-id="element-100" />
        <div className="absolute w-32 h-32 rounded-full bg-[#ecdfb8]/40 blur-2xl -bottom-8 -left-8 pointer-events-none" data-id="element-101" />

        <div className="relative text-center" data-id="element-102">
          <span className="inline-block text-[10px] font-bold text-emerald-700 uppercase tracking-[0.2em] mb-3 bg-emerald-50 border border-emerald-200 px-3 py-1 rounded-full" data-id="element-103">
            ✦ 100% Natural ✦
          </span>
          <h3 className="font-serif text-[28px] leading-tight font-light text-[#18120a] mb-2" data-id="element-104">
            Nada que tragar.
            <br data-id="element-105" />
            <span className="italic text-[#9a7838]" data-id="element-106">Nada que cargar.</span>
          </h3>
          <p className="text-xs sm:text-sm text-[#4a3a1a] leading-relaxed max-w-xs mx-auto mb-6" data-id="element-107">
            Si ya estás tomando hormonas, antidepresivos o medicación para la
            tiroides, lo último que querés es sumar otra pastilla más a tu
            mesita de luz. El anillo se pone, y listo.
          </p>

          <div className="grid grid-cols-4 gap-2 mb-5" data-id="element-108">
            {pillars.map((p, i) => <div key={i} className="bg-[#fdfcf7] border border-[#ecdfb8]/60 rounded-2xl py-3 px-1 flex flex-col items-center gap-1.5" data-id="element-109">
                <span className="text-xl leading-none" data-id="element-110">{p.icon}</span>
                <span className="text-[9px] sm:text-[10px] font-extrabold text-[#7a5f2c] uppercase tracking-tight leading-tight text-center" data-id="element-111">
                  {p.label}
                </span>
              </div>)}
          </div>

          <div className="flex items-center justify-center gap-2 text-[11px] font-bold text-emerald-700 bg-emerald-50/60 border border-emerald-200/60 rounded-full py-2.5 px-4" data-id="element-112">
            <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2.5" data-id="element-113">
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-114" />
            </svg>
            <span data-id="element-115">Compatible con TRH, tiroides y cualquier tratamiento</span>
          </div>
        </div>
      </div>
    </section>;
}
export function ANMATWarning() {
  return <section className="px-5 py-10 bg-[#fdfcf7] border-y border-[#ecdfb8]/30" data-id="element-116">
      <div className="text-center mb-6" data-id="element-117">
        <span className="inline-block text-[10px] font-bold text-red-700 uppercase tracking-[0.2em] mb-3 bg-red-50 border border-red-200 px-3 py-1 rounded-full" data-id="element-118">
          ⚠ Algo que nadie te cuenta
        </span>
        <h3 className="font-serif text-[28px] leading-tight font-light text-[#18120a] mb-2" data-id="element-119">
          Las "gotas milagrosas"
          <br data-id="element-120" />
          <span className="italic text-[#9a7838]" data-id="element-121">no tienen ANMAT</span>
        </h3>
        <p className="text-xs sm:text-sm text-[#4a3a1a] leading-relaxed max-w-xs mx-auto" data-id="element-122">
          La mayoría de los productos para bajar de peso que ves en Instagram y
          TikTok se venden sin registro de ANMAT. No sabés qué hay adentro, ni
          quién los fabrica, ni qué le hacen a tu hígado.
        </p>
      </div>

      <div className="bg-white rounded-3xl border border-[#ecdfb8]/60 overflow-hidden shadow-sm mb-5" data-id="element-123">
        <div className="grid grid-cols-2 text-[11px] sm:text-xs" data-id="element-124">
          <div className="p-4 border-r border-[#ecdfb8]/40 bg-red-50/40" data-id="element-125">
            <div className="flex items-center gap-1.5 mb-3" data-id="element-126">
              <span className="w-2 h-2 rounded-full bg-red-500" data-id="element-127" />
              <span className="text-[10px] font-extrabold text-red-700 uppercase tracking-wider" data-id="element-128">
                Lo que se vende
              </span>
            </div>
            <ul className="space-y-2.5 text-[#4a3a1a]" data-id="element-129">
              <li className="flex items-start gap-1.5" data-id="element-130">
                <span className="text-red-500 font-bold mt-0.5" data-id="element-131">✕</span>
                <span data-id="element-132">Gotas y cápsulas sin registro ANMAT</span>
              </li>
              <li className="flex items-start gap-1.5" data-id="element-133">
                <span className="text-red-500 font-bold mt-0.5" data-id="element-134">✕</span>
                <span data-id="element-135">Ingredientes desconocidos o adulterados</span>
              </li>
              <li className="flex items-start gap-1.5" data-id="element-136">
                <span className="text-red-500 font-bold mt-0.5" data-id="element-137">✕</span>
                <span data-id="element-138">Riesgo hepático y cardíaco</span>
              </li>
              <li className="flex items-start gap-1.5" data-id="element-139">
                <span className="text-red-500 font-bold mt-0.5" data-id="element-140">✕</span>
                <span data-id="element-141">Interactúan con tu medicación</span>
              </li>
              <li className="flex items-start gap-1.5" data-id="element-142">
                <span className="text-red-500 font-bold mt-0.5" data-id="element-143">✕</span>
                <span data-id="element-144">Efecto rebote en cuanto los dejás</span>
              </li>
            </ul>
          </div>

          <div className="p-4 bg-[#fdfcf7]" data-id="element-145">
            <div className="flex items-center gap-1.5 mb-3" data-id="element-146">
              <span className="w-2 h-2 rounded-full bg-emerald-500" data-id="element-147" />
              <span className="text-[10px] font-extrabold text-emerald-700 uppercase tracking-wider" data-id="element-148">
                Anillo Atmósfera
              </span>
            </div>
            <ul className="space-y-2.5 text-[#18120a]" data-id="element-149">
              <li className="flex items-start gap-1.5" data-id="element-150">
                <span className="text-emerald-600 font-bold mt-0.5" data-id="element-151">✓</span>
                <span data-id="element-152">No requiere ANMAT (no se ingiere)</span>
              </li>
              <li className="flex items-start gap-1.5" data-id="element-153">
                <span className="text-emerald-600 font-bold mt-0.5" data-id="element-154">✓</span>
                <span data-id="element-155">Acero quirúrgico 316L hipoalergénico</span>
              </li>
              <li className="flex items-start gap-1.5" data-id="element-156">
                <span className="text-emerald-600 font-bold mt-0.5" data-id="element-157">✓</span>
                <span data-id="element-158">Cero efectos sobre el hígado</span>
              </li>
              <li className="flex items-start gap-1.5" data-id="element-159">
                <span className="text-emerald-600 font-bold mt-0.5" data-id="element-160">✓</span>
                <span data-id="element-161">No interactúa con ningún medicamento</span>
              </li>
              <li className="flex items-start gap-1.5" data-id="element-162">
                <span className="text-emerald-600 font-bold mt-0.5" data-id="element-163">✓</span>
                <span data-id="element-164">Sin efecto rebote — lo seguís usando</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="bg-white border border-[#ecdfb8] rounded-3xl p-5" data-id="element-165">
        <div className="flex items-start gap-3" data-id="element-166">
          <div className="flex-shrink-0 w-9 h-9 rounded-full bg-[#ecdfb8]/40 flex items-center justify-center border border-[#ecdfb8]" data-id="element-167">
            <Icons.Shield className="w-4 h-4 text-[#b8924a]" data-id="element-168" />
          </div>
          <div data-id="element-169">
            <p className="text-[11px] font-extrabold text-[#18120a] uppercase tracking-wider mb-1.5" data-id="element-170">
              ¿Por qué el anillo no necesita ANMAT?
            </p>
            <p className="text-[11px] sm:text-xs text-[#4a3a1a] leading-relaxed" data-id="element-171">
              ANMAT regula medicamentos, alimentos y dispositivos que se
              ingieren o implantan. El Anillo Atmósfera es un{' '}
              <strong data-id="element-172">accesorio externo</strong> de acero quirúrgico — la misma
              categoría que una pulsera o un reloj. No entra al cuerpo, no se
              metaboliza, no necesita aprobación sanitaria.
            </p>
          </div>
        </div>
      </div>

      <p className="text-[9px] text-[#7a5f2c] text-center mt-4 italic max-w-xs mx-auto leading-relaxed" data-id="element-173">
        Antes de comprar cualquier "solución milagrosa" pedí siempre el número
        de registro ANMAT. Si no lo tiene, no lo consumas.
      </p>
    </section>;
}
export function ZebrahouseCustom() {
  const benefits = [{
    img: 'https://cdn.shopify.com/s/files/1/0737/3052/3356/files/fat_loss.png?v=1740661954',
    title: 'Quemá la grasa abdominal acumulada',
    desc: 'Los campos magnéticos ayudan a reducir el cortisol, la hormona que le indica al cuerpo que acumule grasa en el abdomen después de los 40. En promedio nuestras usuarias bajan 4-7 kilos en los primeros 60 días.'
  }, {
    img: 'https://cdn.shopify.com/s/files/1/0737/3052/3356/files/improve_sleep.png?v=1740661954',
    title: 'Acelerá tu metabolismo enlentecido',
    desc: 'La menopausia baja el metabolismo un 15%; los imanes estimulan la circulación y la termogénesis. Sentirás menos hinchazón en la primera semana.'
  }, {
    img: 'https://cdn.shopify.com/s/files/1/0737/3052/3356/files/reduce_stress.png?v=1740661954',
    title: 'Reducí ansiedad por comer dulces',
    desc: 'La acupresión calma el cortisol y los antojos nocturnos de azúcar e hidratos.'
  }];
  return <section className="px-5 py-8 bg-white" data-id="element-174">
      <div className="text-left mb-6" data-id="element-175">
        <h3 className="font-serif text-3xl leading-tight font-light text-[#18120a] mb-3" data-id="element-176">
          Diseño elegante que actúa sobre <strong data-id="element-177">tu metabolismo</strong>
        </h3>
        <p className="text-brand-800 text-xs sm:text-sm leading-relaxed" data-id="element-178">
          El Anillo ATMÓSFERA combina una estética sofisticada con cuatro
          magnetos integrados, cuidadosamente posicionados sobre puntos de
          acupresión para ayudarte con el aumento de peso en la menopausia.
        </p>
      </div>

      <div className="space-y-6" data-id="element-179">
        {benefits.map((b, i) => <div key={i} className="flex gap-4 items-start bg-brand-50/20 p-4 rounded-3xl border border-[#ecdfb8]/20" data-id="element-180">
            <img src={b.img} alt={b.title} className="w-10 h-10 object-contain mt-1 flex-shrink-0" data-id="element-181" />
            <div data-id="element-182">
              <h4 className="font-bold text-sm text-ink mb-1" data-id="element-183">{b.title}</h4>
              <p className="text-xs text-[#4a3a1a] leading-relaxed" data-id="element-184">{b.desc}</p>
            </div>
          </div>)}
      </div>
    </section>;
}
export function Reason1() {
  const benefitsList = [{
    title: 'ELIMINA',
    desc: 'la grasa rebelde del abdomen',
    img: 'https://tiendaatmosfera.com/cdn/shop/files/Calmi_-_Zen_350x_bfb3a5ad-608b-4d7e-9eef-554f4a9de951.svg?v=1769712651'
  }, {
    title: 'ACELERA',
    desc: 'el metabolismo enlentecido',
    img: 'https://tiendaatmosfera.com/cdn/shop/files/Calmi_-_Sommeil_350x_7ed88921-ab71-42d7-9b00-0dd6c22b52e7.svg?v=1769712717'
  }, {
    title: 'REDUCE',
    desc: 'la hinchazón y retención',
    img: 'https://tiendaatmosfera.com/cdn/shop/files/Calmi_-_Pain_350x_6fd1fe07-cecd-4cbd-b033-00f61faddc3b.svg?v=1769712717'
  }, {
    title: 'CONTROLA',
    desc: 'los antojos por dulces',
    img: 'https://tiendaatmosfera.com/cdn/shop/files/Calmi_-_Circulation_350x_ec0a4b69-82a9-4857-a803-2d52cb90d8a2.svg?v=1769712717'
  }];
  return <section className="px-5 py-8 relative" data-id="element-185">
      <div className="flex items-start gap-4 mb-6" data-id="element-186">
        <span className="font-serif text-8xl font-light italic text-[#ecdfb8] leading-none -mt-4 select-none" data-id="element-187">
          1
        </span>
        <div data-id="element-188">
          <h3 className="font-serif text-[26px] font-light text-[#18120a] leading-tight mb-2" data-id="element-189">
            Quema grasa abdominal sin dieta extrema
          </h3>
          <p className="text-[#4a3a1a] text-sm leading-relaxed" data-id="element-190">
            Después de los 40, el cortisol se dispara y el cuerpo almacena grasa
            en el abdomen. La acupresión constante sobre puntos meridianos ayuda
            a regular el cortisol para que el cuerpo deje de acumular grasa
            abdominal.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-3.5 mb-6" data-id="element-191">
        {benefitsList.map((b, i) => <div key={i} className="bg-white/70 p-4 rounded-3xl border border-[#ecdfb8]/30 flex flex-col items-center text-center shadow-xs" data-id="element-192">
            <img src={b.img} alt={b.title} className="w-12 h-12 object-contain mb-2.5" data-id="element-193" />
            <span className="text-[10px] font-extrabold text-[#7a5f2c] uppercase tracking-wider" data-id="element-194">
              {b.title}
            </span>
            <p className="text-[10px] text-brand-800 leading-tight mt-1" data-id="element-195">
              {b.desc}
            </p>
          </div>)}
      </div>

      <div className="bg-white/50 backdrop-blur-xl rounded-3xl shadow-glass overflow-hidden border border-white/70" data-id="element-196">
        <table className="w-full text-[11px] sm:text-xs text-center border-collapse" data-id="element-197">
          <thead data-id="element-198">
            <tr className="border-b border-[#ecdfb8]/40 bg-brand-100/20 text-[#7a5f2c]" data-id="element-199">
              <th className="py-3.5 px-3 text-left font-bold w-2/5" data-id="element-200">
                Característica
              </th>
              <th className="py-3.5 px-1 font-extrabold text-[#b8924a] bg-[#ecdfb8]/10" data-id="element-201">
                Atmósfera
              </th>
              <th className="py-3.5 px-1 font-medium text-gray-500" data-id="element-202">
                Dietas Restrictivas
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-brand-100/10 text-[#18120a]" data-id="element-203">
            {[['Reduce grasa abdominal', true, true], ['Sin pasar hambre', true, false], ['Sin efecto rebote', true, false], ['Sin esfuerzo diario', true, false]].map((row, i) => <tr key={i} className="hover:bg-brand-50/50 transition-colors" data-id="element-204">
                <td className="py-3 px-3 text-left font-semibold text-[#18120a]" data-id="element-205">
                  {row[0]}
                </td>
                <td className="py-3 px-1 bg-[#ecdfb8]/5" data-id="element-206">
                  {row[1] ? <div className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-[#b8924a]/15" data-id="element-207">
                      <Icons.Check className="w-3.5 h-3.5 text-[#b8924a]" data-id="element-208" />
                    </div> : <Icons.X className="mx-auto text-gray-300" data-id="element-209" />}
                </td>
                <td className="py-3 px-1" data-id="element-210">
                  {row[2] ? <Icons.Check className="mx-auto text-gray-400 w-3.5 h-3.5" data-id="element-211" /> : <Icons.X className="mx-auto text-gray-300 w-3.5 h-3.5" data-id="element-212" />}
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </section>;
}
export function Reason2() {
  const testimonials = [{
    name: 'Graciela P. (54 años - Rosario)',
    text: 'Bajé 7 kg en 3 meses sin hacer dieta. Los calores del mediodía me ponían de pésimo humor, pero lo que más me sorprendió fue cómo se desinfló mi panza.',
    tag: '-7 KG'
  }, {
    name: 'Silvia B. (49 años - Córdoba)',
    text: 'Volví a usar mis jeans de hace 5 años. Un antes y un después para la retención de líquidos. Me lo coloco en el dedo medio y siento una ligereza casi instantánea.',
    tag: '-3 TALLES'
  }];
  return <section className="px-5 py-8 relative" data-id="element-213">
      <div className="flex items-start gap-4 mb-6" data-id="element-214">
        <span className="font-serif text-8xl font-light italic text-[#ecdfb8] leading-none -mt-4 select-none" data-id="element-215">
          2
        </span>
        <div data-id="element-216">
          <h3 className="font-serif text-[26px] font-light text-[#18120a] leading-tight mb-2" data-id="element-217">
            Decile adiós a la hinchazón abdominal
          </h3>
          <p className="text-[#4a3a1a] text-sm leading-relaxed" data-id="element-218">
            Los cambios hormonales causan retención de líquidos e hinchazón que
            suman 2-4 cm a la cintura. La acupresión magnética mejora el drenaje
            linfático y reduce la hinchazón visible en días.
          </p>
        </div>
      </div>

      <div className="space-y-4" data-id="element-219">
        {testimonials.map((t, i) => <div key={i} className="bg-white/50 backdrop-blur-xl p-4.5 rounded-3xl shadow-glass border border-white/70 flex gap-3.5 items-start" data-id="element-220">
            <div className="bg-[#b8924a]/10 text-brand-600 p-2.5 rounded-2xl flex-shrink-0" data-id="element-221">
              <Icons.Star className="w-4 h-4 text-[#b8924a] fill-[#b8924a]" data-id="element-222" />
            </div>
            <div data-id="element-223">
              <div className="flex flex-wrap items-center gap-2 mb-1.5" data-id="element-224">
                <span className="font-bold text-xs sm:text-sm text-[#18120a]" data-id="element-225">
                  {t.name}
                </span>
                <span className="text-[9px] font-extrabold text-[#7a5f2c] bg-[#ecdfb8]/30 px-2.5 py-0.5 rounded-full uppercase tracking-wider" data-id="element-226">
                  {t.tag}
                </span>
              </div>
              <p className="text-xs sm:text-sm text-[#4a3a1a] italic leading-relaxed" data-id="element-227">
                "{t.text}"
              </p>
            </div>
          </div>)}
      </div>
    </section>;
}
export function UGCVideos() {
  const videos = ['https://cdn-cf-east.streamable.com/video/mp4/5ezj6d.mp4?Expires=1780700280&Signature=dF7cTIeHWh1fqb~VW1LcMipAhM4758PfkQ5wKrIUTkUq~t6MhD7-6ZQM9aetLB7PnMOvwt1~4R9nX-oghmsaw533A8UDWistlroTi4j6zOMEWmKZpOsNyYwXL0oqvjRXD0gcVo6g2UeGXLL-k8uOgOE6QqpS5htphtNdeGlNYZK8kB5Nu~dwlJUinaITplb1FO5aTy4RZOBPiOdbhZiZenJPHi--18tk2pOG010r07-S3V4iWUFIipedPTinBJ3vGQ27qO31~8a3u1BPfamSnr7lMCzQTxUufHuOxBBacUXfdyhpef~TcvaAzMsleeyioCbe1V89gKLSsjZRV3MWAQ__&Key-Pair-Id=APKAIEYUVEN4EVB2OKEQ', 'https://cdn-cf-east.streamable.com/video/mp4/zwv0mx.mp4?Expires=1780700280&Signature=Ed~SV6YSQBMN6TYG4eWlYa19jPw4WDeluRktFF9W7BK9VHq4xBnWUz9h1SA73Tp~CnWGHQKoOmSXQ7BbPC~TF18kg9Vi5HNXVcwW1s18cpIDu5IuTYIRXCq599J7zqQ-uEK0I6XEroghVbvDPmrTV17j3qgoosfuz2J0fn0yV3714f7vferrg4A9lP5Viv6Os8qmcoYU3O40yyNauPKWNefcdZTwS5NTFB8TCyGah8R25QMRx1pMpiy-9nm9jsKUEYSyhxMK5B7WWuiNEbCwLqsUn9iCArFcezpiVzBbvE1K6n9Sdu0QMEtaPF-5eBrfKBF1tGv2p~hDzJTPVToWTg__&Key-Pair-Id=APKAIEYUVEN4EVB2OKEQ', 'https://cdn-cf-east.streamable.com/video/mp4/us6xcy.mp4?Expires=1780700280&Signature=U-ONi46mXRu4L8NbocGugt8kf5bX5gpZvLfVTMuFy-CJYRayfIaiRrtdrdHgnJrOwqU1r-iYVJT8vptk8jmrLb9wntfbURIReWhjJswopDE6VLNRPh-hMomCQ~b4ItM5mU7YeRIOR7xmjA4A-I9aB~osS3m0zjzuaumvfaL8stSQi4NXS-KLhLEeyqj-YdSpOo2KpRAM4lUpqWzqCoQUzlHmxF2MaONbAF2fsks99MTU1lAdVCvPkDko4phYRWQm9jxPpyA0KRhX3ieJ6WDHKG5UDGdOC3427zHjxtQc-dFRFFbwxz5pAzRbGS9rx1U24rR3i-6NwOD23EB8jpNnlA__&Key-Pair-Id=APKAIEYUVEN4EVB2OKEQ'];
  return <section className="px-5 py-12 bg-white text-center" data-id="element-228">
      <p className="text-[10px] sm:text-[11px] font-bold text-[#b8924a] uppercase tracking-[0.32em] mb-4" data-id="element-229">
        Clientas Reales
      </p>
      <h3 className="font-serif text-[32px] sm:text-[36px] leading-[1.1] font-medium text-[#18120a] mb-3" data-id="element-230">
        Resultados reales.
        <br data-id="element-231" />
        Sin filtros.
      </h3>
      <p className="text-xs sm:text-sm text-[#7a5f2c] leading-relaxed max-w-sm mx-auto mb-8" data-id="element-232">
        Mientras la competencia usa imágenes de IA, nosotras mostramos personas
        reales.
      </p>

      <div className="grid grid-cols-3 gap-2" data-id="element-233">
        {videos.map((src, i) => <VideoCard key={i} src={src} data-id="element-234" />)}
      </div>
    </section>;
}
export function VideoCard({
  src
}: {
  src: string;
}) {
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);
  const handlePlay = () => {
    setIsPlaying(true);
    setTimeout(() => {
      videoRef.current?.play();
    }, 50);
  };
  return <div className="relative aspect-[9/16] rounded-2xl overflow-hidden bg-[#18120a] shadow-lg ring-1 ring-black/5 border border-white/60" data-id="element-235">
      <video ref={videoRef} src={src} className="w-full h-full object-cover" playsInline preload="metadata" controls={isPlaying} onClick={() => !isPlaying && handlePlay()} onEnded={() => setIsPlaying(false)} data-id="element-236" />

      {!isPlaying && <button onClick={handlePlay} className="absolute inset-0 flex items-center justify-center group bg-black/10" aria-label="Reproducir testimonio" data-id="element-237">
          <div className="w-12 h-12 rounded-full bg-white/95 flex items-center justify-center shadow-xl border-2 border-white group-hover:scale-110 transition-transform" data-id="element-238">
            <svg className="w-5 h-5 text-[#18120a] ml-0.5" fill="currentColor" viewBox="0 0 24 24" data-id="element-239">
              <path d="M8 5v14l11-7z" data-id="element-240" />
            </svg>
          </div>
        </button>}
    </div>;
}
export function Reason3() {
  return <section className="px-5 py-8 relative" data-id="element-241">
      <div className="flex items-start gap-4 mb-6" data-id="element-242">
        <span className="font-serif text-8xl font-light italic text-[#ecdfb8] leading-none -mt-4 select-none" data-id="element-243">
          3
        </span>
        <div data-id="element-244">
          <h3 className="font-serif text-[26px] font-light text-[#18120a] leading-tight mb-2" data-id="element-245">
            Dormí mejor y adelgazá mientras dormís
          </h3>
          <p className="text-[#4a3a1a] text-sm leading-relaxed" data-id="element-246">
            Dormir mal eleva la grelina (hormona del hambre) y baja la leptina
            (saciedad), causando aumento de peso. El anillo promueve el sueño
            profundo, que es cuando el cuerpo quema más grasa.
          </p>
        </div>
      </div>

      <div className="bg-white/50 backdrop-blur-xl p-5 rounded-[32px] shadow-glass border border-white/70 mb-4 relative overflow-hidden" data-id="element-247">
        <div className="absolute top-4 right-4 bg-emerald-50 text-emerald-700 text-[10px] font-bold px-2.5 py-1 rounded-full flex items-center gap-1 border border-emerald-200" data-id="element-248">
          <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-ping" data-id="element-249" />
          Testimonio Real
        </div>

        <div className="flex items-center gap-3 mb-4" data-id="element-250">
          <div className="w-11 h-11 rounded-full bg-[#ecdfb8]/40 overflow-hidden ring-2 ring-white shadow-sm flex items-center justify-center font-bold text-[#7a5f2c] text-sm font-serif" data-id="element-251">
            AM
          </div>
          <div data-id="element-252">
            <p className="font-bold text-xs sm:text-sm text-[#18120a]" data-id="element-253">
              Alicia M. (51 años)
            </p>
            <div className="flex gap-0.5 mt-0.5" data-id="element-254">
              {[...Array(5)].map((_, i) => <Icons.Star key={i} className="w-3 h-3 text-[#b8924a] fill-[#b8924a]" data-id="element-255" />)}
            </div>
          </div>
        </div>
        <p className="text-xs sm:text-sm text-[#4a3a1a] leading-relaxed italic mb-3" data-id="element-256">
          "Hacía dos años que venía subiendo de peso sin parar por culpa de la
          menopausia y no dormía bien. Compré el Anillo Atmósfera sin mucha fe,
          y juro que bajé 5 kg en 2 meses después de empezar a dormir de
          corrido. El mejor regalo para mi cuerpo."
        </p>

        <div className="mt-4 rounded-2xl overflow-hidden border border-[#ecdfb8]/40 bg-[#fdfcf7]" data-id="element-257">
          <img src="https://cdn.magicpatterns.com/uploads/chX4fkh3Ae11ei8z7VLG7q/PHOTO-2026-05-11-13-51-06.jpg" alt="Foto enviada por Alicia M. con su anillo puesto" className="w-full h-auto object-cover max-h-80" data-id="element-258" />
          <div className="px-3 py-2 flex items-center gap-1.5 bg-white" data-id="element-259">
            <svg className="w-3 h-3 text-emerald-600" fill="currentColor" viewBox="0 0 24 24" data-id="element-260">
              <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z" data-id="element-261" />
            </svg>
            <span className="text-[9px] text-[#7a5f2c] font-bold italic" data-id="element-262">
              Foto que Alicia nos mandó con su anillo puesto
            </span>
          </div>
        </div>

        <span className="block text-[10px] text-[#7a5f2c] font-bold tracking-wider uppercase mt-4" data-id="element-263">
          ✦ BAJÓ 5 KG CON EL COMBO DUPLO
        </span>
      </div>
    </section>;
}
export function ScienceSection() {
  const citations = [{
    tag: 'Mecanismo de acción',
    claim: 'Los mecanismos propuestos de la magnetoterapia incluyen el aumento del flujo sanguíneo, la reducción de la inflamación y la liberación de endorfinas.',
    source: 'Markov MS, Environmentalist (2007) • PMC Bibliometric Review'
  }, {
    tag: 'Sueño y biorritmo',
    claim: 'Para el insomnio, la magnetoterapia mejora la calidad del sueño, posiblemente al influir sobre el biorritmo del cuerpo.',
    source: 'Markov MS, Med Radiol Radiat Saf (2018)'
  }, {
    tag: 'Acupresión + campos magnéticos',
    claim: 'La terapia magnética con acupuntura aplica imanes sobre puntos específicos de la piel, combinando los conceptos de la acupuntura con campos magnéticos para reequilibrar el flujo de energía del cuerpo y estimular el proceso de curación.',
    source: 'Fu L, Xu G, Yu H. IEEE Transactions on Magnetics (2017)'
  }];
  return <section className="px-5 py-10 bg-gradient-to-b from-[#fdfcf7] to-white border-y border-[#ecdfb8]/30" data-id="element-264">
      <div className="text-center mb-6" data-id="element-265">
        <span className="inline-block text-[10px] font-bold text-[#7a5f2c] uppercase tracking-[0.2em] mb-3 bg-white border border-[#ecdfb8] px-3 py-1 rounded-full" data-id="element-266">
          ✦ Lo que dice la ciencia ✦
        </span>
        <h3 className="font-serif text-3xl font-light text-[#18120a] mb-2 leading-tight" data-id="element-267">
          No es magia.
          <br data-id="element-268" />
          <span className="italic text-[#9a7838]" data-id="element-269">Es magnetoterapia.</span>
        </h3>
      </div>

      <div className="bg-[#18120a] rounded-[28px] p-5 mb-6 text-center text-white relative overflow-hidden" data-id="element-270">
        <div className="absolute inset-0 bg-gradient-to-br from-[#b8924a]/20 to-transparent pointer-events-none" data-id="element-271" />
        <div className="relative" data-id="element-272">
          <div className="font-serif text-5xl font-light text-[#ecdfb8] mb-1 leading-none" data-id="element-273">
            2.351
          </div>
          <p className="text-[11px] text-[#ecdfb8]/90 font-bold uppercase tracking-widest mb-3" data-id="element-274">
            Estudios científicos revisados
          </p>
          <p className="text-[11px] text-white/80 leading-relaxed max-w-xs mx-auto" data-id="element-275">
            Una revisión bibliométrica de Scopus analizó 2.351 publicaciones
            sobre magnetoterapia desde 1945 hasta 2024 — con un crecimiento
            anual del 5,23%.
          </p>
        </div>
      </div>

      <div className="space-y-3.5 mb-5" data-id="element-276">
        {citations.map((c, i) => <div key={i} className="bg-white rounded-3xl border border-[#ecdfb8]/50 p-4.5 shadow-sm" data-id="element-277">
            <span className="inline-block text-[9px] font-extrabold text-[#b8924a] uppercase tracking-widest bg-[#ecdfb8]/30 px-2.5 py-1 rounded-full mb-2.5" data-id="element-278">
              {c.tag}
            </span>
            <p className="font-serif text-sm sm:text-base text-[#18120a] leading-snug italic mb-2.5" data-id="element-279">
              "{c.claim}"
            </p>
            <p className="text-[10px] text-[#7a5f2c] font-medium border-t border-[#ecdfb8]/40 pt-2" data-id="element-280">
              Fuente: {c.source}
            </p>
          </div>)}
      </div>

      <p className="text-[10px] text-[#7a5f2c] text-center leading-relaxed max-w-xs mx-auto italic" data-id="element-281">
        Citas extraídas de la revisión bibliométrica publicada en PMC11470392
        (Cureus, 2024) sobre la evidencia científica de la magnetoterapia.
      </p>
    </section>;
}
export function Reason4() {
  const features = [{
    icon: Icons.Flame,
    label: 'Metabolismo Activo'
  }, {
    icon: Icons.Moon,
    label: 'Quema Grasa'
  }, {
    icon: Icons.Acupressure,
    label: 'Acupresión Activa'
  }];
  return <section className="px-5 py-8 relative" data-id="element-282">
      <div className="flex items-start gap-4 mb-6" data-id="element-283">
        <span className="font-serif text-8xl font-light italic text-[#ecdfb8] leading-none -mt-4 select-none" data-id="element-284">
          4
        </span>
        <div data-id="element-285">
          <h3 className="font-serif text-[26px] font-light text-[#18120a] leading-tight mb-2" data-id="element-286">
            Se adapta aunque cambies de talla
          </h3>
          <p className="text-[#4a3a1a] text-sm leading-relaxed" data-id="element-287">
            A medida que vas perdiendo centímetros, tus dedos también se afinan.
            Su exclusivo diseño abierto permite expandirlo o cerrarlo
            suavemente, readaptándose para que el anillo siga funcionando en
            toda tu transformación.
          </p>
        </div>
      </div>

      <div className="bg-white/50 backdrop-blur-xl p-5 rounded-[32px] shadow-glass border border-white/70 mb-5" data-id="element-288">
        <div className="flex items-center gap-2.5 mb-4 text-[#7a5f2c] font-bold text-xs uppercase tracking-widest" data-id="element-289">
          <Icons.Shield className="w-5 h-5 text-[#b8924a]" data-id="element-290" />
          Beneficios Certificados de Diseño
        </div>

        <div className="space-y-3" data-id="element-291">
          <div className="bg-white/60 p-3.5 rounded-2xl border-l-4 border-[#b8924a] shadow-sm" data-id="element-292">
            <p className="text-xs font-bold text-[#18120a] mb-1" data-id="element-293">
              Hipoalergénico de Grado Quirúrgico
            </p>
            <p className="text-[11px] text-[#7a5f2c]" data-id="element-294">
              Construido en acero quirúrgico 316L libre de níquel. Ideal para
              las pieles más sensibles del climaterio.
            </p>
          </div>
          <div className="bg-white/60 p-3.5 rounded-2xl border-l-4 border-[#b8924a] shadow-sm" data-id="element-295">
            <p className="text-xs font-bold text-[#18120a] mb-1" data-id="element-296">
              Ajuste Flexible sin herramientas
            </p>
            <p className="text-[11px] text-[#7a5f2c]" data-id="element-297">
              Podés cambiarlo de dedo según el momento del día para estimular
              distintos puntos de acupresión.
            </p>
          </div>
        </div>
      </div>

      <div className="flex flex-wrap gap-2.5 justify-center" data-id="element-298">
        {features.map((f, i) => <div key={i} className="flex items-center gap-2 bg-white/70 backdrop-blur px-4 py-2.5 rounded-full shadow-sm border border-brand-300/30" data-id="element-299">
            <f.icon className="w-4 h-4 text-[#b8924a]" data-id="element-300" />
            <span className="text-[11px] font-bold text-[#18120a]" data-id="element-301">
              {f.label}
            </span>
          </div>)}
      </div>
    </section>;
}
export function Reason5() {
  const benefits = ['Resultados visibles en 30 días', 'Sin pastillas ni efectos secundarios', 'No interfiere con tratamientos hormonales', 'Apto para uso continuo las 24 hs'];
  return <section className="px-5 py-8 relative" data-id="element-302">
      <div className="flex items-start gap-4 mb-6" data-id="element-303">
        <span className="font-serif text-8xl font-light italic text-[#ecdfb8] leading-none -mt-4 select-none" data-id="element-304">
          5
        </span>
        <div data-id="element-305">
          <h3 className="font-serif text-[26px] font-light text-[#18120a] leading-tight mb-2" data-id="element-306">
            Adelgazá con estilo, sin que nadie lo note
          </h3>
          <p className="text-[#4a3a1a] text-sm leading-relaxed" data-id="element-307">
            Una joya elegante que nadie sabe que está trabajando para vos. Sin
            dietas que explicar en los almuerzos familiares, sin pastillas que
            tomar frente a tus amigas. Solo elegancia.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-3 mb-5" data-id="element-308">
        <div className="aspect-[3/4] rounded-[28px] overflow-hidden shadow-glass border border-white/60 relative" data-id="element-309">
          <img src="https://tiendaatmosfera.com/cdn/shop/files/Calmara-Magnetig-Chrome-Ring-model-2.webp?v=1771468095" alt="Modelo Usando Anillo Atmósfera" className="w-full h-full object-cover" data-id="element-310" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" data-id="element-311" />
          <span className="absolute bottom-3 left-3 text-[10px] text-white font-bold tracking-widest uppercase" data-id="element-312">
            Elegancia
          </span>
        </div>
        <div className="aspect-[3/4] rounded-[28px] overflow-hidden shadow-glass border border-white/60 relative" data-id="element-313">
          <img src="https://tiendaatmosfera.com/cdn/shop/files/chrome_ring.webp?v=1769712814" alt="Detalle Detallado del Anillo" className="w-full h-full object-cover" data-id="element-314" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" data-id="element-315" />
          <span className="absolute bottom-3 left-3 text-[10px] text-white font-bold tracking-widest uppercase" data-id="element-316">
            Acero 316L
          </span>
        </div>
      </div>

      <div className="space-y-2" data-id="element-317">
        {benefits.map((benefit, i) => <div key={i} className="flex items-center gap-3 bg-white/50 backdrop-blur p-3 rounded-2xl border border-white/77" data-id="element-318">
            <div className="bg-[#b8924a]/15 p-1 rounded-lg" data-id="element-319">
              <Icons.Check className="w-4 h-4 text-[#b8924a]" data-id="element-320" />
            </div>
            <span className="text-xs sm:text-sm font-bold text-[#18120a]" data-id="element-321">
              {benefit}
            </span>
          </div>)}
      </div>
    </section>;
}
export function ComfortRichText() {
  return <section className="px-5 py-10 bg-brand-100/10 border-t border-[#ecdfb8]/20 text-center" data-id="element-322">
      <h3 className="font-serif text-3xl font-light text-[#18120a] mb-3" data-id="element-323">
        Funciona en todos los cuerpos
      </h3>
      <p className="text-sm text-[#4a3a1a] max-w-xs mx-auto leading-relaxed" data-id="element-324">
        A medida que vas bajando de peso y tus dedos cambian, el anillo se
        reajusta. Tu aliado constante en toda la transformación.
      </p>
    </section>;
}
export function ProductSummary() {
  const checklist = ['Pérdida de peso natural y sostenida', 'Reducción de grasa abdominal (cortisol)', 'Material 100% hipoalergénico (Acero 316L)', 'Envío rápido y gratuito a tu casa', '30 días de garantía o devolvemos tu dinero'];
  return <section className="px-5 py-8 relative" data-id="element-325">
      <div className="bg-gradient-to-br from-[#fdfcf7] to-white rounded-[36px] shadow-glass border border-white p-6" data-id="element-326">
        <div className="w-full aspect-square rounded-2xl overflow-hidden mb-5 bg-[#f7f1e1]/40 border border-[#ecdfb8]/50 flex items-center justify-center p-2" data-id="element-327">
          <img src="https://tiendaatmosfera.com/cdn/shop/files/imagen_final.jpg?v=1779117073&width=1240" alt="Anillo Atmósfera" className="w-full h-full object-cover rounded-xl" data-id="element-328" />
        </div>

        <h3 className="font-serif text-3xl font-light text-[#18120a] mb-2.5 italic tracking-wide" data-id="element-329">
          Anillo Atmósfera
        </h3>
        <p className="text-xs sm:text-sm text-[#4a3a1a] leading-relaxed mb-5" data-id="element-330">
          La sutil e indolora fusión de la ciencia biomagnética con alta joyería
          de diseño. Un accesorio minimalista de calce adaptable ideado para
          reactivar tu metabolismo y ayudarte a perder peso de forma discreta y
          armónica.
        </p>

        <div className="space-y-3" data-id="element-331">
          {checklist.map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-332">
              <div className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-[#b8924a]/20 flex-shrink-0" data-id="element-333">
                <Icons.Check className="w-3.5 h-3.5 text-[#b8924a]" data-id="element-334" />
              </div>
              <span className="text-xs sm:text-sm text-[#18120a] font-medium leading-tight" data-id="element-335">
                {item}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}
export function ObjectionsBlock() {
  const objections = [{
    question: '"¿No será otra estafa más?"',
    answer: 'Por eso te damos 30 días reales para probarlo. Si en un mes no ves cambios en tu peso, tu hinchazón o tu medida de cintura, te devolvemos el 100% sin preguntas. No estarías arriesgando nada — solo el costo de seguir igual.',
    icon: '🛡️'
  }, {
    question: '"No quiero sumar otra pastilla más"',
    answer: 'No hay nada que tragar. No es un suplemento, no es una hormona, no es un té milagroso. Es un anillo de acero quirúrgico con imanes integrados. Lo ponés, lo usás, y listo — compatible con cualquier medicación que ya estés tomando.',
    icon: '🌿'
  }, {
    question: '"Yo ya probé de todo y nada me funciona"',
    answer: 'Las dietas y el gym fallan después de los 45 porque atacan las calorías, no la causa real: el cortisol y el metabolismo lento de la menopausia. El anillo trabaja exactamente sobre los puntos meridianos que regulan esas hormonas. Por eso funciona donde lo demás no.',
    icon: '✦'
  }, {
    question: '"¿Cómo puede algo tan chico hacer tanto?"',
    answer: 'No es el tamaño, es la ubicación. Los 4 imanes están posicionados sobre puntos de acupresión específicos del dedo medio que la medicina tradicional china identificó hace miles de años — los mismos que hoy 2.351 estudios científicos relacionan con metabolismo, sueño y regulación hormonal.',
    icon: '🔬'
  }];
  return <section className="px-5 py-10 bg-[#18120a] relative overflow-hidden" data-id="element-336">
      <div className="absolute w-64 h-64 rounded-full bg-[#b8924a]/15 blur-3xl -top-20 -right-20 pointer-events-none" data-id="element-337" />
      <div className="absolute w-72 h-72 rounded-full bg-[#ecdfb8]/10 blur-3xl bottom-0 -left-20 pointer-events-none" data-id="element-338" />

      <div className="relative" data-id="element-339">
        <div className="text-center mb-7" data-id="element-340">
          <span className="inline-block text-[10px] font-bold text-[#ecdfb8] uppercase tracking-[0.2em] mb-3 border border-[#b8924a]/40 px-3 py-1 rounded-full" data-id="element-341">
            ✦ Antes de decidir ✦
          </span>
          <h3 className="font-serif text-3xl font-light text-white mb-2 leading-tight" data-id="element-342">
            Sí, también pensamos lo mismo
            <br data-id="element-343" />
            <span className="italic text-[#ecdfb8]" data-id="element-344">la primera vez</span>
          </h3>
          <p className="text-xs text-white/70 max-w-xs mx-auto leading-relaxed" data-id="element-345">
            Estas son las 3 dudas que más nos llegan por WhatsApp. Te las
            contestamos sin vueltas.
          </p>
        </div>

        <div className="space-y-3.5" data-id="element-346">
          {objections.map((o, i) => <div key={i} className="bg-white/5 backdrop-blur-md rounded-3xl border border-white/10 p-5" data-id="element-347">
              <div className="flex items-start gap-3 mb-2.5" data-id="element-348">
                <span className="text-xl flex-shrink-0 leading-none mt-0.5" data-id="element-349">
                  {o.icon}
                </span>
                <h4 className="font-serif text-base sm:text-lg font-medium text-[#ecdfb8] italic leading-snug" data-id="element-350">
                  {o.question}
                </h4>
              </div>
              <p className="text-xs sm:text-sm text-white/85 leading-relaxed pl-8" data-id="element-351">
                {o.answer}
              </p>
            </div>)}
        </div>

        <div className="mt-7 bg-[#b8924a]/15 border border-[#b8924a]/30 rounded-2xl p-4 text-center" data-id="element-352">
          <p className="text-[11px] text-[#ecdfb8] font-bold leading-relaxed" data-id="element-353">
            ✦ 30 días para probarlo o te devolvemos el 100% ✦
          </p>
        </div>
      </div>
    </section>;
}
export function PricingSection({
  selectedColor,
  setSelectedColor,
  selectedPack,
  setSelectedPack,
  onBuyClick
}: any) {
  const [timeLeft, setTimeLeft] = useState({
    hours: 3,
    minutes: 42,
    seconds: 18
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) seconds--;else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        } else {
          hours = 3;
          minutes = 59;
          seconds = 59;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (num: number) => String(num).padStart(2, '0');
  return <section id="comprar" className="px-5 py-8 relative" data-id="element-354">
      <div className="flex justify-center mb-6" data-id="element-355">
        <div className="w-16 h-px bg-brand-400/50" data-id="element-356" />
      </div>
      <h2 className="font-serif text-3xl font-light text-[#18120a] text-center mb-1.5" data-id="element-357">
        Elegí tu Plan de Transformación
      </h2>
      <p className="text-xs text-[#7a5f2c] text-center font-bold uppercase tracking-wider mb-6" data-id="element-358">
        ✦ Envío gratis + 30 días para ver resultados ✦
      </p>

      <div className="flex items-center justify-center gap-2.5 mb-8 bg-[#fdfcf7] border border-[#ecdfb8] rounded-2xl py-3 px-4 max-w-xs mx-auto shadow-sm" data-id="element-359">
        <span className="text-[11px] font-extrabold text-[#7a5f2c] uppercase tracking-wider animate-pulse" data-id="element-360">
          Oferta expira en:
        </span>
        <div className="flex items-center gap-1 font-mono text-sm font-bold text-[#18120a]" data-id="element-361">
          <span className="bg-[#18120a] text-white px-2 py-1 rounded-md text-xs" data-id="element-362">
            {formatTime(timeLeft.hours)}
          </span>
          <span data-id="element-363">:</span>
          <span className="bg-[#18120a] text-white px-2 py-1 rounded-md text-xs" data-id="element-364">
            {formatTime(timeLeft.minutes)}
          </span>
          <span data-id="element-365">:</span>
          <span className="bg-[#18120a] text-white px-2 py-1 rounded-md text-xs" data-id="element-366">
            {formatTime(timeLeft.seconds)}
          </span>
        </div>
      </div>

      <div className="space-y-4 mb-6" data-id="element-367">
        <div onClick={() => setSelectedPack('single')} className={`cursor-pointer rounded-3xl p-5 transition-all relative border ${selectedPack === 'single' ? 'bg-white shadow-lg border-[#b8924a] ring-2 ring-[#b8924a]/20 scale-[1.01]' : 'bg-white/40 border-gray-100 hover:bg-white/60'}`} data-id="element-368">
          <div className="flex justify-between items-start mb-2.5" data-id="element-369">
            <div data-id="element-370">
              <h3 className="font-serif text-xl font-bold text-[#18120a]" data-id="element-371">
                1 Anillo
              </h3>
              <p className="text-xs text-[#7a5f2c]" data-id="element-372">
                Probá la transformación natural
              </p>
            </div>
            <div className="text-right" data-id="element-373">
              <span className="text-[11px] text-gray-400 line-through" data-id="element-374">
                $64.990
              </span>
              <p className="text-xl sm:text-2xl font-extrabold text-[#18120a]" data-id="element-375">
                $53.990
              </p>
            </div>
          </div>
          <div className="flex justify-between items-center mt-3 pt-3 border-t border-brand-100/30" data-id="element-376">
            <span className="bg-brand-100/50 text-[#7a5f2c] text-[10px] font-extrabold px-3 py-1 rounded-full border border-brand-200/40" data-id="element-377">
              Ahorrás $11.000
            </span>
            <span className="text-[10px] text-brand-600 font-bold" data-id="element-378">
              Ajustable (Talle único)
            </span>
          </div>
        </div>

        <div onClick={() => setSelectedPack('double')} className={`cursor-pointer rounded-3xl p-5 transition-all relative border ${selectedPack === 'double' ? 'bg-white shadow-lg border-[#b8924a] ring-2 ring-[#b8924a]/20 scale-[1.01]' : 'bg-white/40 border-gray-100 hover:bg-white/60'}`} data-id="element-379">
          <div className="absolute -top-3 left-6 bg-[#b8924a] text-white text-[9px] font-extrabold tracking-widest px-3 py-1 rounded-full shadow" data-id="element-380">
            PAGÁ 1 LLEVATE 2 (RECOMENDADO)
          </div>
          <div className="flex justify-between items-start mb-2.5 mt-1.5" data-id="element-381">
            <div data-id="element-382">
              <h3 className="font-serif text-xl font-bold text-[#18120a]" data-id="element-383">
                2 Anillos
              </h3>
              <p className="text-xs text-[#7a5f2c]" data-id="element-384">
                Resultados duplicados — usá en ambas manos
              </p>
            </div>
            <div className="text-right" data-id="element-385">
              <span className="text-[11px] text-gray-400 line-through" data-id="element-386">
                $129.980
              </span>
              <p className="text-xl sm:text-2xl font-extrabold text-[#18120a]" data-id="element-387">
                $53.990
              </p>
            </div>
          </div>
          <div className="flex justify-between items-center mt-3 pt-3 border-t border-brand-100/30" data-id="element-388">
            <span className="bg-[#b8924a] text-white text-[10px] font-extrabold px-3 py-1 rounded-full" data-id="element-389">
              ¡Ahorrás $75.990! Envío Gratis
            </span>
            <span className="text-[10px] text-brand-600 font-bold" data-id="element-390">
              2 anillos adaptables
            </span>
          </div>
        </div>

        <div onClick={() => setSelectedPack('quad')} className={`cursor-pointer rounded-3xl p-5 transition-all relative border ${selectedPack === 'quad' ? 'bg-white shadow-lg border-[#b8924a] ring-2 ring-[#b8924a]/20 scale-[1.01]' : 'bg-white/40 border-gray-100 hover:bg-white/60'}`} data-id="element-391">
          <div className="absolute -top-3 left-6 bg-[#18120a] text-white text-[9px] font-extrabold tracking-widest px-3 py-1 rounded-full shadow" data-id="element-392">
            PAGÁ 2 LLEVATE 4 (TRATAMIENTO COMPLETO)
          </div>
          <div className="flex justify-between items-start mb-2.5 mt-1.5" data-id="element-393">
            <div data-id="element-394">
              <h3 className="font-serif text-xl font-bold text-[#18120a]" data-id="element-395">
                4 Anillos
              </h3>
              <p className="text-xs text-[#7a5f2c]" data-id="element-396">
                Transformación total — protocolo completo
              </p>
            </div>
            <div className="text-right" data-id="element-397">
              <span className="text-[11px] text-gray-400 line-through" data-id="element-398">
                $259.960
              </span>
              <p className="text-xl sm:text-2xl font-extrabold text-[#18120a]" data-id="element-399">
                $107.980
              </p>
            </div>
          </div>
          <div className="flex justify-between items-center mt-3 pt-3 border-t border-brand-100/30" data-id="element-400">
            <span className="bg-emerald-600 text-white text-[10px] font-extrabold px-3 py-1 rounded-full" data-id="element-401">
              3 Cuotas s/Interés • Ahorrás $151.980
            </span>
            <span className="text-[10px] text-brand-600 font-bold" data-id="element-402">
              4 anillos adaptables
            </span>
          </div>
        </div>
      </div>

      <div className="bg-white/50 backdrop-blur rounded-[28px] p-4.5 border border-white/80 space-y-3 mb-6" data-id="element-403">
        <div data-id="element-404">
          <label className="block text-[11px] font-bold uppercase text-[#7a5f2c] mb-1.5" data-id="element-405">
            Color Deseado
          </label>
          <select value={selectedColor} onChange={e => setSelectedColor(e.target.value)} className="w-full bg-white border border-[#ecdfb8]/50 rounded-xl px-3 py-2.5 text-xs font-bold text-[#18120a]" data-id="element-406">
            <option value="Plata" data-id="element-407">Plata Platino</option>
            <option value="Oro" data-id="element-408">Oro Champagne</option>
            <option value="Oro Rosa" data-id="element-409">Oro Rosa Premium</option>
            <option value="Negro" data-id="element-410">Negro Obsidiana</option>
          </select>
        </div>
      </div>

      <button onClick={() => onBuyClick(selectedPack, selectedColor)} className="w-full bg-[#18120a] hover:bg-[#4a3a1a] text-white font-bold tracking-widest uppercase py-4 px-6 rounded-full shadow-lg transition-all active:scale-98 text-xs flex items-center justify-center gap-2" data-id="element-411">
        <span data-id="element-412">COMPRAR AHORA</span>
        <Icons.Check className="w-4 h-4 text-[#ecdfb8]" data-id="element-413" />
      </button>

      <div className="flex flex-wrap items-center justify-center gap-2 mt-5 bg-white/30 py-3.5 rounded-2xl border border-white/50" data-id="element-414">
        <span className="text-[10px] text-[#7a5f2c] font-bold uppercase mr-1" data-id="element-415">
          Medios de pago:
        </span>
        {['Mercado Pago', '3 Cuotas Sin Interés', 'Efectivo / Rapipago', 'Transferencia (10% OFF)'].map((method, i) => <div key={i} className="bg-white px-2 py-1 rounded-md text-[9px] font-bold text-[#4a3a1a] border border-brand-200/50" data-id="element-416">
            {method}
          </div>)}
      </div>
    </section>;
}
export function ReviewsSection() {
  const [reviewsList, setReviewsList] = useState([{
    name: 'Nélida S. (56 años)',
    date: 'Hace 1 día',
    stars: 5,
    text: 'Bajé 6 kilos en 2 meses sin cambiar nada de mi rutina. Yo no podía creerlo porque venía estancada hace 3 años desde la menopausia. Mi nutricionista quedó sin palabras.',
    photo: 'https://cdn.magicpatterns.com/uploads/a8uBEm4iuxdbtRYcQNDLkg/PHOTO-2026-05-13-15-40-46.jpg'
  }, {
    name: 'Clara M. (50 años)',
    date: 'Hace 4 días',
    stars: 5,
    text: 'Lo compré porque me había hinchado muchísimo en el climaterio. Perdí 4 cm de cintura en 3 semanas. Vuelvo a verme bien en el espejo.',
    photo: 'https://cdn.magicpatterns.com/uploads/daKwXLmUD2kNsfsP82DRdt/PHOTO-2026-05-13-15-18-17.jpg'
  }, {
    name: 'Isabel R. (52 años)',
    date: 'Hace 1 semana',
    stars: 5,
    text: 'Bajé un talle completo en 6 semanas. Llegó rapidísimo a Mendoza y ya se lo regalé a mi hermana que también está con sobrepeso de menopausia.',
    photo: null
  }]);
  const [newReview, setNewReview] = useState({
    name: '',
    text: '',
    stars: 5
  });
  const [showForm, setShowForm] = useState(false);
  const handleSubmitReview = (e: React.FormEvent) => {
    e.preventDefault();
    if (!newReview.name || !newReview.text) return;
    setReviewsList([{
      name: newReview.name,
      date: 'Hace un momento',
      stars: newReview.stars,
      text: newReview.text,
      photo: null
    }, ...reviewsList]);
    setNewReview({
      name: '',
      text: '',
      stars: 5
    });
    setShowForm(false);
  };
  return <section className="px-5 py-8 relative" data-id="element-417">
      <div className="flex justify-center mb-6" data-id="element-418">
        <div className="w-16 h-px bg-brand-400/50" data-id="element-419" />
      </div>
      <h2 className="font-serif text-3xl font-light text-[#18120a] text-center mb-6" data-id="element-420">
        Comunidad Atmósfera
      </h2>

      <div className="bg-[#fdfcf7] rounded-3xl p-5 border border-[#ecdfb8]/50 text-center mb-6" data-id="element-421">
        <div className="text-4.5xl font-serif font-light text-[#18120a] mb-1" data-id="element-422">
          4.9 / 5.0
        </div>
        <div className="flex justify-center gap-0.5 mb-2" data-id="element-423">
          {[...Array(5)].map((_, i) => <Icons.Star key={i} className="w-4 h-4 text-[#b8924a] fill-[#b8924a]" data-id="element-424" />)}
        </div>
        <p className="text-xs text-[#7a5f2c] font-medium" data-id="element-425">
          Basado en más de 12.000 transformaciones reales en Argentina
        </p>
      </div>

      {/* WhatsApp screenshots — unfakeable social proof */}
      <div className="mb-7" data-id="element-426">
        <div className="text-center mb-4" data-id="element-427">
          <span className="inline-block text-[10px] font-bold text-emerald-700 uppercase tracking-[0.2em] bg-emerald-50 border border-emerald-200 px-3 py-1 rounded-full" data-id="element-428">
            ✦ Mensajes reales sin filtros ✦
          </span>
        </div>
        <p className="text-center text-xs text-[#7a5f2c] mb-5 max-w-xs mx-auto leading-relaxed" data-id="element-429">
          Capturas directas de WhatsApp de clientas que nos escribieron por su
          cuenta después de recibir el anillo.
        </p>

        <div className="relative h-[420px] mx-auto max-w-[320px]" data-id="element-430">
          <div className="absolute top-0 left-0 w-[170px] sm:w-[180px] transform -rotate-3 z-10 hover:rotate-0 hover:scale-105 hover:z-30 transition-all duration-500" data-id="element-431">
            <div className="bg-white rounded-2xl border border-[#ecdfb8]/60 shadow-2xl overflow-hidden ring-1 ring-black/5" data-id="element-432">
              <img src="https://cdn.magicpatterns.com/uploads/agsoWbnmDf51Hzs2TYnr9s/PHOTO-2026-05-14-10-53-10.jpg" alt="Mensaje de Alejandra Mercado" className="w-full h-auto object-cover" data-id="element-433" />
              <div className="px-3 py-2 bg-white border-t border-[#ecdfb8]/40" data-id="element-434">
                <p className="text-[10px] font-bold text-[#18120a]" data-id="element-435">
                  Alejandra Mercado
                </p>
                <p className="text-[9px] text-emerald-600 font-bold" data-id="element-436">
                  Cliente verificada ✓
                </p>
              </div>
            </div>
          </div>

          <div className="absolute top-12 right-0 w-[170px] sm:w-[180px] transform rotate-3 z-20 hover:rotate-0 hover:scale-105 hover:z-30 transition-all duration-500" data-id="element-437">
            <div className="bg-white rounded-2xl border border-[#ecdfb8]/60 shadow-2xl overflow-hidden ring-1 ring-black/5" data-id="element-438">
              <img src="https://cdn.magicpatterns.com/uploads/chX4fkh3Ae11ei8z7VLG7q/PHOTO-2026-05-11-13-51-06.jpg" alt="Mensaje de Angélica Bravo" className="w-full h-auto object-cover" data-id="element-439" />
              <div className="px-3 py-2 bg-white border-t border-[#ecdfb8]/40" data-id="element-440">
                <p className="text-[10px] font-bold text-[#18120a]" data-id="element-441">
                  Angélica Bravo
                </p>
                <p className="text-[9px] text-emerald-600 font-bold" data-id="element-442">
                  Cliente verificada ✓
                </p>
              </div>
            </div>
          </div>

          <span className="absolute -bottom-2 left-1/2 -translate-x-1/2 text-[10px] text-[#7a5f2c] font-medium italic" data-id="element-443">
            Tocá una captura para verla en grande
          </span>
        </div>
      </div>

      <div className="text-center mb-6" data-id="element-444">
        <button onClick={() => setShowForm(!showForm)} className="bg-white hover:bg-[#fdfcf7] border border-[#ecdfb8] text-[#7a5f2c] text-xs font-bold px-4 py-2 rounded-full shadow-sm transition-colors" data-id="element-445">
          {showForm ? 'Cancelar opinión' : '★ Escribir mi opinión'}
        </button>
      </div>

      {showForm && <form onSubmit={handleSubmitReview} className="bg-white border border-[#ecdfb8] rounded-2xl p-4.5 mb-6 space-y-3.5" data-id="element-446">
          <div data-id="element-447">
            <label className="block text-[11px] font-bold text-[#7a5f2c] uppercase mb-1" data-id="element-448">
              Tu Nombre y Edad
            </label>
            <input type="text" required placeholder="Ej: Graciela P. (53 años)" value={newReview.name} onChange={e => setNewReview({
          ...newReview,
          name: e.target.value
        })} className="w-full bg-cream border border-brand-200/50 rounded-xl px-3 py-2 text-xs focus:outline-none" data-id="element-449" />
          </div>
          <div data-id="element-450">
            <label className="block text-[11px] font-bold text-[#7a5f2c] uppercase mb-1" data-id="element-451">
              Calificación
            </label>
            <div className="flex gap-1.5" data-id="element-452">
              {[1, 2, 3, 4, 5].map(star => <button type="button" key={star} onClick={() => setNewReview({
            ...newReview,
            stars: star
          })} className="p-1 focus:outline-none" data-id="element-453">
                  <Icons.Star className={`w-6 h-6 ${star <= newReview.stars ? 'text-[#b8924a] fill-[#b8924a]' : 'text-gray-200'}`} data-id="element-454" />
                </button>)}
            </div>
          </div>
          <div data-id="element-455">
            <label className="block text-[11px] font-bold text-[#7a5f2c] uppercase mb-1" data-id="element-456">
              Tu Comentario
            </label>
            <textarea required rows={3} placeholder="Contanos tu experiencia..." value={newReview.text} onChange={e => setNewReview({
          ...newReview,
          text: e.target.value
        })} className="w-full bg-cream border border-brand-200/50 rounded-xl px-3 py-2 text-xs focus:outline-none" data-id="element-457" />
          </div>
          <button type="submit" className="w-full bg-[#b8924a] text-white text-xs font-bold py-2.5 rounded-xl uppercase tracking-wider" data-id="element-458">
            Publicar Opinión Verificada
          </button>
        </form>}

      <div className="space-y-4" data-id="element-459">
        {reviewsList.map((review, i) => <div key={i} className="bg-white/40 p-5 rounded-3xl border border-white/80 shadow-sm" data-id="element-460">
            <div className="flex justify-between items-start mb-2.5" data-id="element-461">
              <div data-id="element-462">
                <span className="font-bold text-xs sm:text-sm text-[#18120a]" data-id="element-463">
                  {review.name}
                </span>
                <span className="text-[10px] text-emerald-600 font-bold block mt-0.5" data-id="element-464">
                  Compra Verificada ✓
                </span>
              </div>
              <span className="text-[10px] text-brand-600" data-id="element-465">{review.date}</span>
            </div>
            <div className="flex gap-0.5 mb-2.5" data-id="element-466">
              {[...Array(5)].map((_, j) => <Icons.Star key={j} className={`w-3.5 h-3.5 ${j < review.stars ? 'text-[#b8924a] fill-[#b8924a]' : 'text-gray-200'}`} data-id="element-467" />)}
            </div>
            <p className="text-xs sm:text-sm text-[#4a3a1a] leading-relaxed mb-3" data-id="element-468">
              {review.text}
            </p>
            {review.photo && <div className="mt-3 rounded-2xl overflow-hidden border border-[#ecdfb8]/40 bg-[#fdfcf7]" data-id="element-469">
                <img src={review.photo} alt={`Foto enviada por ${review.name}`} className="w-full h-auto object-cover max-h-72" data-id="element-470" />
                <div className="px-3 py-2 flex items-center gap-1.5 bg-white" data-id="element-471">
                  <svg className="w-3 h-3 text-emerald-600" fill="currentColor" viewBox="0 0 24 24" data-id="element-472">
                    <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z" data-id="element-473" />
                  </svg>
                  <span className="text-[9px] text-[#7a5f2c] font-bold italic" data-id="element-474">
                    Foto enviada por {review.name.split(' ')[0]}
                  </span>
                </div>
              </div>}
          </div>)}
      </div>
    </section>;
}
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: '¿En cuánto tiempo voy a empezar a bajar de peso?',
    a: 'La mayoría nota menos hinchazón en la primera semana y pérdida de peso visible entre los 30 y 60 días. Resultados promedio: 4-7 kg en los primeros 2 meses, usándolo 24 hs.'
  }, {
    q: '¿Tengo que hacer dieta o ejercicio para que funcione?',
    a: 'No es necesario hacer dieta restrictiva ni gimnasio. El anillo actúa sobre el cortisol y el metabolismo. Obviamente, una alimentación equilibrada potencia los resultados.'
  }, {
    q: '¿Funciona si tengo hipotiroidismo o estoy con TRH?',
    a: 'Sí. Es 100% natural y compatible con cualquier tratamiento médico. Muchas de nuestras usuarias con tiroides o terapia hormonal logran resultados.'
  }, {
    q: '¿Qué pasa si no veo resultados?',
    a: 'Tenés 30 días de garantía total. Si no notás cambios en tu peso o medidas, te devolvemos el 100% de tu dinero sin preguntas.'
  }];
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="px-5 py-8 relative" data-id="element-475">
      <div className="flex justify-center mb-6" data-id="element-476">
        <div className="w-16 h-px bg-brand-400/50" data-id="element-477" />
      </div>
      <h2 className="font-serif text-3xl font-light text-[#18120a] text-center mb-6" data-id="element-478">
        Preguntas Frecuentes
      </h2>

      <div className="space-y-3" data-id="element-479">
        {faqs.map((faq, i) => {
        const isOpen = openIndex === i;
        return <div key={i} className="bg-white/40 backdrop-blur rounded-2xl border border-white/80 overflow-hidden shadow-sm" data-id="element-480">
              <button onClick={() => toggleFaq(i)} className="w-full px-5 py-4 flex items-center justify-between text-left focus:outline-none" data-id="element-481">
                <span className="font-bold text-xs sm:text-sm text-[#18120a] pr-4" data-id="element-482">
                  {faq.q}
                </span>
                <span className={`transform transition-transform duration-300 ${isOpen ? 'rotate-180' : 'rotate-0'}`} data-id="element-483">
                  <Icons.ChevronDown className="w-4 h-4 text-[#b8924a]" data-id="element-484" />
                </span>
              </button>
              <div className={`transition-all duration-300 overflow-hidden ${isOpen ? 'max-h-48 border-t border-brand-100/30' : 'max-h-0'}`} data-id="element-485">
                <div className="p-5 text-xs sm:text-sm text-[#4a3a1a] leading-relaxed bg-brand-50/10" data-id="element-486">
                  {faq.a}
                </div>
              </div>
            </div>;
      })}
      </div>
    </section>;
}
export function FinalCTA() {
  const scrollToPricing = () => {
    document.getElementById('comprar')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="px-5 py-12 text-center bg-gradient-to-t from-[#f7f1e1]/20 to-transparent" data-id="element-487">
      <div className="max-w-[280px] mx-auto overflow-hidden rounded-[24px] shadow-lg border border-white mb-6" data-id="element-488">
        <img src="https://tiendaatmosfera.com/cdn/shop/files/Fichier_4_1_700x_0dd31b35-c86c-4d0b-ae29-27b31fd3765c.webp?v=1769712157" alt="Elegancia y balance" className="w-full h-auto object-cover" data-id="element-489" />
      </div>

      <h2 className="font-serif text-[34px] leading-tight font-light text-[#18120a] mb-3 italic" data-id="element-490">
        Recuperá el cuerpo que extrañás
      </h2>
      <p className="text-xs sm:text-sm text-[#4a3a1a] mb-8 max-w-xs mx-auto" data-id="element-491">
        Sumate a las miles de argentinas que volvieron a su peso ideal después
        de los 45, de forma natural y sin sacrificios.
      </p>

      <button onClick={scrollToPricing} className="w-full max-w-xs bg-[#b8924a] hover:bg-[#9a7838] text-white font-bold tracking-widest uppercase py-4 px-6 rounded-full shadow-lg transition-transform active:scale-95 text-xs animate-pulse-gold" data-id="element-492">
        QUIERO BAJAR DE PESO YA
      </button>

      <div className="flex justify-center gap-4 mt-6 text-[10px] font-bold text-[#7a5f2c] uppercase tracking-wider" data-id="element-493">
        <span data-id="element-494">✦ Envío Gratis</span>
        <span data-id="element-495">✦ 30 Días Garantía</span>
        <span data-id="element-496">✦ Resultados Visibles</span>
      </div>
    </section>;
}
export function CheckoutModal({
  pack,
  color,
  onClose,
  orderCompleted,
  setOrderCompleted
}: any) {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    address: '',
    city: '',
    province: 'CABA',
    zip: ''
  });
  const [paymentMethod, setPaymentMethod] = useState('mp');
  const [isSubmitting, setIsSubmitting] = useState(false);
  let price = 53990;
  let description = '1 Anillo Atmósfera';
  if (pack === 'double') {
    price = 53990;
    description = '2 Anillos Atmósfera (Pagá 1 Llevate 2)';
  } else if (pack === 'quad') {
    price = 107980;
    description = '4 Anillos Atmósfera (Pagá 2 Llevate 4)';
  }
  const provinces = ['CABA', 'Buenos Aires', 'Córdoba', 'Santa Fe', 'Mendoza', 'Neuquén', 'Tucumán', 'Entre Ríos', 'Salta', 'San Juan', 'Otras'];
  const handlePurchase = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setTimeout(() => {
      setIsSubmitting(false);
      setOrderCompleted(true);
    }, 1800);
  };
  return <div className="absolute inset-0 bg-black/60 backdrop-blur-xs z-50 flex items-end justify-center transition-opacity animate-fade-in" data-id="element-497">
      <div className="bg-white w-full max-h-[92%] rounded-t-[32px] overflow-y-auto p-6 shadow-2xl relative flex flex-col justify-between border-t border-[#ecdfb8]" data-id="element-498">
        <button onClick={onClose} className="absolute top-5 right-5 p-1 rounded-full bg-[#fdfcf7] hover:bg-[#f7f1e1] border border-[#ecdfb8]/50 text-gray-500 z-10" data-id="element-499">
          <Icons.X className="w-5 h-5" data-id="element-500" />
        </button>

        {!orderCompleted ? <div data-id="element-501">
            <div className="text-center mb-6" data-id="element-502">
              <span className="font-serif text-xs italic text-[#7a5f2c] tracking-widest block uppercase mb-1" data-id="element-503">
                PROCESO 100% SEGURO
              </span>
              <h3 className="font-serif text-2xl font-light text-[#18120a]" data-id="element-504">
                Finalizá tu Solicitud
              </h3>
            </div>

            <div className="bg-brand-50 border border-brand-200/50 rounded-2xl p-4 mb-5 text-xs space-y-2" data-id="element-505">
              <div className="flex justify-between font-bold text-[#18120a]" data-id="element-506">
                <span data-id="element-507">Producto:</span>
                <span className="text-right" data-id="element-508">
                  {description} ({color})
                </span>
              </div>
              <div className="flex justify-between text-[#7a5f2c]" data-id="element-509">
                <span data-id="element-510">Envío a Domicilio:</span>
                <span className="font-bold text-emerald-600" data-id="element-511">¡GRATIS!</span>
              </div>
              <div className="flex justify-between text-[14px] font-extrabold text-[#18120a] pt-2 border-t border-brand-200/30" data-id="element-512">
                <span data-id="element-513">Total a pagar:</span>
                <span data-id="element-514">
                  $
                  {(paymentMethod === 'transfer' ? price * 0.9 : price).toLocaleString('es-AR')}{' '}
                  ARS
                </span>
              </div>
            </div>

            <form onSubmit={handlePurchase} className="space-y-4" data-id="element-515">
              <div className="grid grid-cols-2 gap-3" data-id="element-516">
                <div data-id="element-517">
                  <label className="block text-[10px] font-bold text-[#7a5f2c] uppercase mb-1" data-id="element-518">
                    Nombre Completo
                  </label>
                  <input type="text" required placeholder="Ej: Graciela Gómez" value={formData.name} onChange={e => setFormData({
                ...formData,
                name: e.target.value
              })} className="w-full bg-cream border border-[#ecdfb8]/60 rounded-xl px-3 py-2 text-xs focus:ring-1 focus:ring-brand-500" data-id="element-519" />
                </div>
                <div data-id="element-520">
                  <label className="block text-[10px] font-bold text-[#7a5f2c] uppercase mb-1" data-id="element-521">
                    Email
                  </label>
                  <input type="email" required placeholder="Ej: graciela@gmail.com" value={formData.email} onChange={e => setFormData({
                ...formData,
                email: e.target.value
              })} className="w-full bg-cream border border-[#ecdfb8]/60 rounded-xl px-3 py-2 text-xs focus:ring-1 focus:ring-brand-500" data-id="element-522" />
                </div>
              </div>

              <div className="grid grid-cols-2 gap-3" data-id="element-523">
                <div data-id="element-524">
                  <label className="block text-[10px] font-bold text-[#7a5f2c] uppercase mb-1" data-id="element-525">
                    WhatsApp de contacto
                  </label>
                  <input type="tel" required placeholder="Ej: 1123456789" value={formData.phone} onChange={e => setFormData({
                ...formData,
                phone: e.target.value
              })} className="w-full bg-cream border border-[#ecdfb8]/60 rounded-xl px-3 py-2 text-xs focus:ring-1 focus:ring-brand-500" data-id="element-526" />
                </div>
                <div data-id="element-527">
                  <label className="block text-[10px] font-bold text-[#7a5f2c] uppercase mb-1" data-id="element-528">
                    Dirección de Entrega
                  </label>
                  <input type="text" required placeholder="Ej: Av. Santa Fe 3456, 3C" value={formData.address} onChange={e => setFormData({
                ...formData,
                address: e.target.value
              })} className="w-full bg-cream border border-[#ecdfb8]/60 rounded-xl px-3 py-2 text-xs focus:ring-1 focus:ring-brand-500" data-id="element-529" />
                </div>
              </div>

              <div className="grid grid-cols-3 gap-2" data-id="element-530">
                <div className="col-span-2" data-id="element-531">
                  <label className="block text-[10px] font-bold text-[#7a5f2c] uppercase mb-1" data-id="element-532">
                    Provincia
                  </label>
                  <select value={formData.province} onChange={e => setFormData({
                ...formData,
                province: e.target.value
              })} className="w-full bg-cream border border-[#ecdfb8]/60 rounded-xl px-3 py-2 text-xs font-bold focus:ring-1 focus:ring-brand-500" data-id="element-533">
                    {provinces.map(p => <option key={p} value={p} data-id="element-534">
                        {p}
                      </option>)}
                  </select>
                </div>
                <div data-id="element-535">
                  <label className="block text-[10px] font-bold text-[#7a5f2c] uppercase mb-1" data-id="element-536">
                    Cód. Postal
                  </label>
                  <input type="text" required placeholder="C1425" value={formData.zip} onChange={e => setFormData({
                ...formData,
                zip: e.target.value
              })} className="w-full bg-cream border border-[#ecdfb8]/60 rounded-xl px-3 py-2 text-xs focus:ring-1 focus:ring-brand-500" data-id="element-537" />
                </div>
              </div>

              <div data-id="element-538">
                <label className="block text-[10px] font-bold text-[#7a5f2c] uppercase mb-2" data-id="element-539">
                  Método de Pago
                </label>
                <div className="grid grid-cols-2 gap-2" data-id="element-540">
                  <button type="button" onClick={() => setPaymentMethod('mp')} className={`p-3 rounded-xl border flex flex-col items-center justify-center transition-all ${paymentMethod === 'mp' ? 'border-[#b8924a] bg-brand-50' : 'border-gray-100 bg-white'}`} data-id="element-541">
                    <span className="text-xs font-extrabold text-[#1a1410]" data-id="element-542">
                      Mercado Pago
                    </span>
                    <span className="text-[9px] text-[#7a5f2c]" data-id="element-543">
                      Saldos y Tarjetas
                    </span>
                  </button>
                  <button type="button" onClick={() => setPaymentMethod('transfer')} className={`p-3 rounded-xl border flex flex-col items-center justify-center transition-all ${paymentMethod === 'transfer' ? 'border-[#b8924a] bg-brand-50' : 'border-gray-100 bg-white'}`} data-id="element-544">
                    <span className="text-xs font-extrabold text-[#1a1410]" data-id="element-545">
                      Transferencia
                    </span>
                    <span className="text-[9px] text-[#7a5f2c]" data-id="element-546">
                      10% de Descuento Extra
                    </span>
                  </button>
                </div>
              </div>

              <button type="submit" disabled={isSubmitting} className="w-full bg-[#18120a] hover:bg-[#2c1f0f] text-white font-bold tracking-widest uppercase py-3.5 px-6 rounded-full shadow-lg transition-transform active:scale-95 text-xs flex items-center justify-center gap-2" data-id="element-547">
                {isSubmitting ? <span className="animate-pulse" data-id="element-548">PROCESANDO SOLICITUD...</span> : <span data-id="element-549">
                    CONFIRMAR COMPRA DE $
                    {paymentMethod === 'transfer' ? (price * 0.9).toLocaleString('es-AR') : price.toLocaleString('es-AR')}
                  </span>}
              </button>
            </form>
          </div> : <div className="text-center py-8 space-y-6" data-id="element-550">
            <div className="w-16 h-16 bg-emerald-50 rounded-full flex items-center justify-center mx-auto border border-emerald-200" data-id="element-551">
              <Icons.Check className="w-8 h-8 text-emerald-600" data-id="element-552" />
            </div>
            <div data-id="element-553">
              <h3 className="font-serif text-3xl font-light text-ink mb-2" data-id="element-554">
                ¡Muchas gracias, {formData.name || 'Princesa'}!
              </h3>
              <p className="text-xs sm:text-sm text-brand-800 leading-relaxed max-w-xs mx-auto" data-id="element-555">
                Tu pedido de Anillo Atmósfera ({color}, ajustable) ha sido
                registrado con éxito. Nos pondremos en contacto a tu WhatsApp
                para coordinar el envío gratis a tu domicilio.
              </p>
            </div>
            <div className="bg-[#fdfcf7] border border-[#ecdfb8] rounded-2xl p-4 max-w-xs mx-auto text-xs space-y-2" data-id="element-556">
              <p className="font-bold text-brand-900" data-id="element-557">
                Número de Pedido: #ATM-{(Math.random() * 10000).toFixed(0)}
              </p>
              <p className="text-[10px] text-brand-700" data-id="element-558">
                Te enviamos todos los detalles a {formData.email}
              </p>
            </div>
            <button onClick={onClose} className="w-full bg-[#b8924a] text-white font-bold py-3 px-6 rounded-full tracking-widest text-xs uppercase" data-id="element-559">
              Cerrar y Seguir Navegando
            </button>
          </div>}
      </div>
    </div>;
}
export function Footer() {
  return <footer className="bg-white/40 backdrop-blur-md px-5 py-12 text-center border-t border-brand-200/40 relative" data-id="element-560">
      <img src="https://tiendaatmosfera.com/cdn/shop/files/Negro.png?v=1769627225&width=130" alt="ATMOSFERA" className="h-7 mx-auto object-contain mb-6 grayscale" data-id="element-561" />

      <div className="flex justify-center gap-6 mb-6 text-[11px] font-bold uppercase tracking-wider text-[#7a5f2c]" data-id="element-562">
        <a href="#comprar" className="hover:text-brand-500 transition-colors" data-id="element-563">
          Comprar
        </a>
        <a href="#" className="hover:text-brand-500 transition-colors" data-id="element-564">
          Términos
        </a>
        <a href="#" className="hover:text-brand-500 transition-colors" data-id="element-565">
          Contacto
        </a>
      </div>

      <div className="flex justify-center gap-2 mb-6" data-id="element-566">
        {['Mercado Pago', 'Visa', 'Mastercard', 'Rapipago'].map((method, i) => <div key={i} className="bg-white/60 backdrop-blur px-2.5 py-1 rounded text-[9px] font-bold text-brand-700 border border-brand-200/40" data-id="element-567">
            {method}
          </div>)}
      </div>

      <p className="text-[9px] text-[#7a5f2c] opacity-80 leading-relaxed max-w-xs mx-auto" data-id="element-568">
        © {new Date().getFullYear()} Atmósfera. Todos los derechos reservados.
        <br data-id="element-569" />
        Desarrollado con altos estándares de biocompatibilidad para tu
        transformación corporal en Argentina.
      </p>
    </footer>;
}